import React from "react";

interface TabsProps {
    tabs: string[];
    activeTab: string;
    onTabChange: (tab: string) => void;
}

const Tabs: React.FC<TabsProps> = ({ tabs, activeTab, onTabChange }) => {
    return (
        <div className="flex flex-row">
            <div className="p-1 flex flex-row gap-2 bg-white rounded-full">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        onClick={() => onTabChange(tab)}
                        className={`p-2 rounded-full px-3 text-sm font-medium transition-all ${activeTab === tab
                                ? "bg-primary-red text-white"
                                : "text-black"
                            }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Tabs;
